import { MinusOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Button, Space, Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';

const SearchRowWrapper = styled.div`
  .select {
    flex: 1;
  }
  .input {
    flex: 2;
    margin-left: -1px;
    margin-right: -1px;
  }
  .button {
    flex: 0;
  }
`;
const SearchSelectCol = styled.div`
  flex: 1;
`;
const SearchInputCol = styled.div`
  flex: 2;
  margin-left: -1px;
  margin-right: -1px;
`;
const SearchButtonCol = styled.div`
  flex: 0;
`;

export interface SearchRowProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  select?: React.ReactNode;
  input?: React.ReactNode;
  disableRemove?: boolean;
  onRemove?: () => void;
}

/**
 * Riga della ricerca con tre colonne: select, input e button
 */
export function SearchRow(props: SearchRowProps) {
  const { select, input, disableRemove, onRemove, ...divProps } = props;
  const { t } = useTranslation();
  return (
    <SearchRowWrapper {...divProps}>
      <Space.Compact block size="middle">
        <SearchSelectCol>{props.select}</SearchSelectCol>
        <SearchInputCol>{props.input}</SearchInputCol>
        <SearchButtonCol>
          <Tooltip
            placement="right"
            title={t(
              'search.component.search-row.remove-filter-button.tooltips',
              'Rimuovi Filtro',
            )}
          >
            <Button
              aria-label={t(
                'search.component.search-row.remove-filter-button.aria-label',
                'Rimuovi Filtro',
              )}
              onClick={onRemove}
              disabled={disableRemove}
              icon={<MinusOutlined aria-hidden />}
            />
          </Tooltip>
        </SearchButtonCol>
      </Space.Compact>
    </SearchRowWrapper>
  );
}
